<template>
  <div class="dashboardServicesCards__card">
    <div
      class="dashboardServicesCards__card"
      @click="$emit('select-case-request-type',requestType)"
    >
      <div class="dashboardServicesCards__card scrollAnimation scrollAnimation--active">
        <div class="dashboardServicesCards__cardWrapper">
          <div
            v-if="requestType.showTag"
            class="servicesTagsItemsCont"
          >
            <span class="dashboardServicesTags dashboardServicesTags__new">
              <i class="icon icon-category_justice pl-2" />
              {{ local.common.new }}
            </span>
          </div>
          <h6 class="icon-category_justice dashboardServicesCards__serviceType icon">
            {{ local.bankruptcy.bankruptcy }}
          </h6>
          <p class="dashboardServicesCards__serviceDescription">
            {{ requestType.title }}

            <small class="d-block small text-muted dashboardServicesCards__Des">
              {{ requestType.shortExplanation }}
            </small>
          </p>
          <span class="dashboardServicesCards__moreLink"> {{ local.common.submitRequest }} </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'SubRequestTypeCard',
  components: {},
  props: {
    requestType: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {
  },
  methods: {},
};

</script>

<style lang="scss" scoped>
::v-deep .naj-button {
  span {
    font-weight: normal !important;
    font-size: 13px !important;
  }
}

span.dashboardServicesTags {
  display: block;
  font-size: 10px;
  padding: 0px 12px;
  background-color: #f1f1f1;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  color: #fff;
  margin: 0px 3px;
}

span.dashboardServicesTags.dashboardServicesTags__new {
  background-color: #067377;
  color: #fff;
}

.servicesTagsItemsCont {
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  padding: 0px 16px;
}

.dashboardServicesCards__Des {
  font-weight: normal;
  font-size: 12px;
  padding-top: 8px;
}
.dashboardServicesCards__serviceDescription {
  margin: 0 !important;
}

.dashboardServicesCards__card {
  &:hover {
    cursor: pointer;
  }
}

.dashboardServicesCards__card span.dashboardServicesCards__moreLink:after {
  width: 46px !important;
  text-align: center !important;
}
</style>
